import { ToasterComponent } from '../../../toasterComponent/toasterComponent';
import { ViewContainerRef } from '@angular/core';
import { MDMService } from '../services/mdmService.service';
import { BiUrls } from '../../biUrls';
import { DataSourceStorageType } from '../pocdesigner/service';
var DataSourceComponent = /** @class */ (function () {
    function DataSourceComponent(dataSourceService, toastr, vcr) {
        this.dataSourceService = dataSourceService;
        this.toastr = toastr;
        this.vcr = vcr;
        // public storageOptions: string[] = [
        //     'FILE_DFS', 'FILE_S3', 'MONGO',
        //     'HIVE', 'HBASE', 'CLASSPATH', 'MYSQL',
        //     'REDIS', 'ORACLE', 'REDSHIFT'];
        this.dataSourceData = {
            id: null, name: '', catalog: '', schema: '', dataSourceCode: '',
            username: '', newPassword: '', type: '', deleted: 0
        };
        this.mainPage = true;
        this.dataSourceReg = '';
        this.lastRegex = '';
        this.sPage = 0;
        this.dataSourcePage = false;
        this.dataSourceList = [];
        this.saveButton = false;
        this.accessDenied = false;
        this.isEdit = false;
        this.noServerName = false;
        this.dataEngineList = [];
        this.pageNo = 0;
        this.pageSize = 10;
        this.startingPage = 0;
        this.currentPage = 1;
        this.totalSource = 0;
        this.totalPages = 0;
        this.loader = false;
        this.isConnection = false;
        this.isSSaSS = false;
        this.toastr.setViewRef(vcr);
    }
    DataSourceComponent.prototype.ngOnInit = function () {
        if (this.dataSourceService.isBIAdmin) {
            this.loadDataSource();
        }
        else {
            this.accessDenied = true;
        }
    };
    DataSourceComponent.prototype.entityOps = function (event) {
        if (this.selectedSourceId == null) {
            this.selectedSourceId = event.target.id;
        }
        else {
            this.selectedSourceId = null;
        }
    };
    DataSourceComponent.prototype.closeDropDown = function (event) {
        this.selectedSourceId = null;
    };
    // For Pagination
    DataSourceComponent.prototype.onPageChange = function (event) {
        this.currentPage = event;
        this.pageNo = this.currentPage - 1;
        if (this.dataSourceReg != '') {
            this.searchPDataSource();
        }
        else {
            this.loadDataSource();
        }
        this.setEndingPage(this.totalSource);
    };
    DataSourceComponent.prototype.setEndingPage = function (total) {
        var self = this;
        if (self.currentPage == 1) {
            this.startingPage = 0;
            if (total > this.pageSize) {
                this.endingPage = this.pageSize;
            }
            else {
                this.endingPage = total;
            }
        }
        else {
            this.startingPage = 0 + ((self.currentPage - 1) * +this.pageSize);
            this.endingPage = +this.pageSize + ((self.currentPage - 1) * +this.pageSize);
            if (this.endingPage > total) {
                this.endingPage = total;
            }
        }
    };
    // For Pagination
    DataSourceComponent.prototype.OnPageSizeChanged = function (event) {
        this.pageSize = event.target.value;
        var maxPage = Math.floor(this.totalSource / this.pageSize);
        if (maxPage < this.pageNo || maxPage < this.sPage) {
            this.pageNo = maxPage;
            this.sPage = this.pageNo;
        }
        this.loadDataSource();
    };
    DataSourceComponent.prototype.loadDataSource = function () {
        var _this = this;
        return new Promise(function (resolve) {
            var self = _this;
            self.loader = true;
            _this.dataSourceService.getDataByPage(BiUrls.DATASOURCE, self.pageNo, self.pageSize).then(function (res) {
                self.dataSourceList = [];
                self.totalPages = 0;
                self.totalSource = 0;
                if (res != undefined) {
                    self.dataSourceList = res.data != undefined &&
                        res.data.pageElements != undefined ? res.data.pageElements :
                        self.toastr.showError('No results found');
                    self.totalSource = res.data != undefined &&
                        res.data.total != undefined ? res.data.total : 0;
                }
                self.setEndingPage(self.totalSource);
                self.loader = false;
                // self.loadEngine();
                resolve('completed');
            }, function (error) {
                console.error(error);
            });
        });
    };
    // By Lalu
    DataSourceComponent.prototype.searchPDataSource = function () {
        var _this = this;
        return new Promise(function (resolve) {
            var self = _this;
            self.loader = true;
            self.mainPage = true;
            self.dataSourceList = [];
            if (self.dataSourceReg != self.lastRegex) {
                self.sPage = 0;
                self.currentPage = 1;
            }
            else {
                self.sPage = self.currentPage - 1;
            }
            self.lastRegex = self.dataSourceReg;
            self.dataSourceService.search(BiUrls.DATASOURCE, BiUrls.SEARCH_P_DATASOURCE, self.dataSourceReg, self.pageNo, self.pageSize).then(function (res) {
                self.loadSearchedPDataSource(res);
                self.loader = false;
            }, function (error) {
                console.error(error);
            });
            resolve('completed');
        });
    };
    // By Lalu
    DataSourceComponent.prototype.loadSearchedPDataSource = function (res) {
        var self = this;
        if (res != undefined) {
            self.dataSourceList = res.data.pageElements;
            self.totalSource = res.data.total;
        }
        else {
            self.totalSource = 0;
        }
        self.setEndingPage(self.totalSource);
    };
    DataSourceComponent.prototype.loadEngineByType = function (dataEngine) {
        var _this = this;
        return new Promise(function (resolve) {
            var self = _this;
            _this.dataSourceService.onStartUp(BiUrls.DATAENGINE + BiUrls.GET_ENGINE_BY_TYPE + dataEngine).then(function (res) {
                res != undefined && res.data != undefined ? (_a = self.dataEngineList).push.apply(_a, res.data) : null;
                resolve('completed');
                var _a;
            });
        });
    };
    DataSourceComponent.prototype.addNewDataSource = function (dsType) {
        var _this = this;
        var storageType = new DataSourceStorageType();
        this.mainPage = false;
        this.dataSourcePage = true;
        var type = storageType[dsType].engineType;
        this.dataEngineList = [];
        if (typeof type == 'string') {
            this.loadEngineByType(storageType[dsType].engineType);
        }
        else {
            type.forEach(function (t) {
                _this.loadEngineByType(t);
            });
        }
        this.parameters = storageType[dsType].customParameter ? storageType[dsType].customParameter : null;
        this.dataSourceData = {
            id: null, name: '', catalog: '', schema: '',
            username: '', newPassword: '', type: '', deleted: 0,
            connection: null,
            customParameter1: null,
            customParameter2: null,
            customParameter3: null,
            customParameter4: null,
            customParameter5: null,
            location: null,
            storageType: dsType,
            dataEngine: null, dataEngineId: null
        };
        // storageType[dsType].type ? storageType[dsType].type :
        this.isConnection = storageType[dsType].connection != undefined ? true : false;
        this.connectionLabel = (this.isConnection && storageType[dsType].connection != '') ?
            storageType[dsType].connection : 'Connection';
    };
    DataSourceComponent.prototype.onSave = function () {
        var self = this;
        var validate = this.validator();
        if (validate != '') {
            self.toastr.showError(validate);
        }
        else {
            self.saveButton = true;
            self.loader = true;
            if (self.isEdit) {
                console.log('ON EDIT');
                self.dataSourceService.update(BiUrls.DATASOURCE, self.dataSourceData).then(function (res) {
                    self.loadAfterSaveOrEdit(res, 'edit');
                });
            }
            else {
                console.log('ON SAVE');
                self.dataSourceService.save(BiUrls.DATASOURCE, self.dataSourceData).then(function (res) {
                    var result = res;
                    self.loadAfterSaveOrEdit(result, 'new');
                });
            }
        }
    };
    DataSourceComponent.prototype.loadAfterSaveOrEdit = function (result, type) {
        var self = this;
        self.totalPages = Math.floor(self.totalSource / self.pageSize);
        self.pageNo = self.isEdit == true ? self.pageNo : self.totalPages;
        var text = type == 'new' ? 'Data Source saved successfully' : 'Changes saved successfully';
        if (self.dataSourceReg != '') {
            self.searchPDataSource().then(function (res) {
                self.setPageFieldsAfterLoading();
                if (result.error == undefined && result.success == true) {
                    self.toastr.showSuccess(text);
                }
                else {
                    self.toastr.showError('Unable to save Data Source');
                }
            });
        }
        else {
            self.setPageFieldsAfterLoading();
            self.loadDataSource().then(function (res) {
                if (result.error == undefined && result.success == true) {
                    self.toastr.showSuccess(text);
                }
                else {
                    self.toastr.showError('Unable to save Data Source');
                }
            }, function (error) {
                console.error(error);
            });
        }
        self.currentPage = self.pageNo + 1;
    };
    DataSourceComponent.prototype.setPageFieldsAfterLoading = function () {
        var self = this;
        self.saveButton = false;
        self.mainPage = true;
        self.selectedSourceId = null;
        self.dataSourcePage = false;
        self.isEdit = false;
        self.loader = false;
    };
    DataSourceComponent.prototype.clickEdit = function (dataSource) {
        var _this = this;
        var self = this;
        self.loader = true;
        self.selectedSourceId = null;
        self.dataSourceService.getDataById(BiUrls.DATASOURCE, dataSource.id).then(function (res) {
            if (res == undefined || res.data == undefined) {
                self.toastr.showError('Cannot load the Data Source');
            }
            else {
                dataSource = res.data;
                _this.isSSaSS = res.data.storageType == 'SQLSERVER' && res.data.dataEngine.type != 'PRESTO';
                self.isEdit = true;
                self.mainPage = false;
                self.dataSourcePage = true;
                self.dataSourceData = JSON.parse(JSON.stringify(dataSource));
            }
            self.setParams();
            self.loader = false;
        }, function (error) {
            console.error(error);
        });
    };
    DataSourceComponent.prototype.setParams = function () {
        if (this.dataSourceData) {
            this.parameters = [];
            this.dataEngineList = [];
            this.dataSourceData.dataEngine.type == 'SSAS' ? this.loadEngineByType('PRESTO') : null;
            this.loadEngineByType(this.dataSourceData.dataEngine.type);
            var DStype = this.dataSourceData.storageType;
            var storageType = new DataSourceStorageType();
            this.isConnection = storageType[DStype].hasOwnProperty('connection') ? true : false;
            if (storageType[DStype]) {
                this.parameters = storageType[DStype].customParameter ? storageType[DStype].customParameter : null;
                this.connectionLabel = (this.isConnection && storageType[DStype].connection != '') ?
                    storageType[DStype].connection : 'Connection';
            }
        }
    };
    // public onSelectStorageType(event) {
    //     let self = this;
    //     self.selectedStorageType = event.target.value;
    //
    // }
    DataSourceComponent.prototype.onBack = function () {
        this.mainPage = true;
        this.dataSourcePage = false;
        this.selectedSourceId = null;
        this.isEdit = false;
    };
    DataSourceComponent.prototype.onTest = function () {
        var self = this;
        var validate = this.validator();
        if (validate != '') {
            self.toastr.showError(validate);
        }
        else {
            self.loader = true;
            self.dataSourceService.testConnection(BiUrls.ANALYTICAL_SERVICE + BiUrls.TEST_CONNECTION, self.dataSourceData).then(function (res) {
                if (res.success && res.message) {
                    self.toastr.showSuccess(res.message);
                }
                else if (res.success) {
                    self.toastr.showSuccess('Data Source Connected successfully');
                }
                else if (res.success == false && res.message != undefined) {
                    self.toastr.showError(res.message);
                }
                else {
                    self.toastr.showError('Failed to Test Data Source Connection');
                }
                self.loader = false;
            });
        }
    };
    DataSourceComponent.prototype.delete = function (dataSource) {
        var self = this;
        self.loader = true;
        self.dataSourceService.delete(BiUrls.DATASOURCE, dataSource.id).then(function (response) {
            if (response.error == undefined) {
                self.toastr.showSuccess(dataSource.name + ' removed successfully');
            }
            else {
                self.toastr.showError('Unable to remove Data Source');
            }
            self.pageNo = self.dataSourceList.length == 1 ?
                self.totalSource == 1 ? 0 : --self.pageNo : self.pageNo;
            self.loadDataSource();
        }, function (error) {
            console.error(error);
        });
    };
    DataSourceComponent.prototype.removeDataSource = function (dataSource) {
        var r = confirm('Are you sure you want to remove the data source '
            + dataSource.name + ' ?');
        if (r == true) {
            this.delete(dataSource);
        }
    };
    DataSourceComponent.prototype.validator = function () {
        var _this = this;
        if (this.dataSourceData.name == undefined || this.dataSourceData.name.trim() == '') {
            return 'Please enter the name it cannot be empty';
        }
        if (this.dataSourceData.dataEngineId == undefined ||
            this.dataSourceData.dataEngineId == null) {
            return 'Please enter the dataEngine it cannot be empty';
        }
        if (!this.isSSaSS && (this.dataSourceData.catalog == undefined || this.dataSourceData.catalog.trim() == '')) {
            return 'Please enter the catalog it cannot be empty';
        }
        if (this.dataSourceData.schema == undefined || this.dataSourceData.schema.trim() == '') {
            return 'Please enter the schema it cannot be empty';
        }
        if (!this.isSSaSS && (this.dataSourceData.location == undefined || this.dataSourceData.location.trim() == '')) {
            return 'Please enter the location it cannot be empty';
        }
        if (!this.isSSaSS && (this.dataSourceData.username == undefined ||
            this.dataSourceData.username.trim() == '')) {
            return 'Please enter the username it cannot be empty';
        }
        if (!this.isSSaSS && this.dataSourceData.id == undefined &&
            (this.dataSourceData.newPassword == undefined ||
                this.dataSourceData.newPassword.trim() == '')) {
            return 'Please enter the password it cannot be empty';
        }
        if (this.parameters && this.parameters.length != 0) {
            var msg_1 = '';
            this.parameters.forEach(function (param, i) {
                if (msg_1 == '') {
                    var dsData = _this.dataSourceData['customParameter' + (i + 1)];
                    if (dsData == undefined || dsData == null || dsData.trim() == '') {
                        msg_1 = 'Please enter the ' + param + ' Parameter it cannot be empty';
                    }
                    else {
                        msg_1 = '';
                    }
                }
                else
                    return;
            });
            return msg_1;
        }
        this.dataSourceData.catalog = this.dataSourceData.catalog != undefined ?
            this.dataSourceData.catalog.trim() : null;
        this.dataSourceData.schema = this.dataSourceData.schema.trim();
        this.dataSourceData.type = this.dataSourceData.type != undefined ?
            this.dataSourceData.type.trim() : null;
        this.dataSourceData.username = this.dataSourceData.username.trim();
        return '';
    };
    DataSourceComponent.prototype.syncDataSource = function (dataSource) {
        var self = this;
        if (dataSource.dataEngine != null && (dataSource.dataEngine.type == 'PRESTO' || dataSource.dataEngine.type == 'SSAS')) {
            var r = confirm('Are you sure you want to sync all record formats for ' + dataSource.name + ' ?');
            if (r) {
                self.dataSourceService.syncAllRecordFormatsInDataSource(dataSource.id).then(function (res) {
                    var msg = res.success == true ? self.toastr.showSuccess('Record formats are synced successfully') :
                        self.toastr.showError('Unable to sync record formats of "' + dataSource.name + '"');
                });
            }
        }
        else {
            var r = confirm('Are you sure you want to sync ' + dataSource.name + ' ?');
            if (r) {
                self.dataSourceService.syncDataSource(dataSource.id).then(function (res) {
                    var msg = res.success == true ? self.toastr.showSuccess('Sync was successful') :
                        self.toastr.showError('Unable to Sync');
                });
            }
        }
    };
    DataSourceComponent.prototype.confirmChangeOfEngine = function (event) {
        if (event.target.value != 'none') {
            if (this.dataSourceData.storageType && this.dataSourceData.storageType == 'SQLSERVER') {
                var ind = this.dataEngineList.findIndex(function (x) { return x.id == +event.target.value; });
                this.isSSaSS = this.dataEngineList[ind].type != 'PRESTO';
                if (this.isSSaSS) {
                    this.dataSourceData.catalog = '';
                    this.dataSourceData.location = '';
                }
            }
            this.dataSourceData.dataEngineId = +event.target.value;
        }
        else {
            this.dataSourceData.dataEngineId = null;
        }
    };
    return DataSourceComponent;
}());
export { DataSourceComponent };



// WEBPACK FOOTER //
// ./src/app/bi/admin/controller/dataSource.component.ts.pre-build-optimizer.js